/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShipmentDraft,
  ShipmentDraftsSummary,
} from '../models/index';
import {
    ShipmentDraftFromJSON,
    ShipmentDraftToJSON,
    ShipmentDraftsSummaryFromJSON,
    ShipmentDraftsSummaryToJSON,
} from '../models/index';

export interface DeleteShipmentDraftRequest {
    shipmentDraftId: string;
}

export interface GetShipmentDraftByIdRequest {
    shipmentDraftId: string;
}

/**
 * 
 */
export class ShipmentDraftsApi extends runtime.BaseAPI {

    /**
     * Deletes shipment draft
     * Your GET endpoint
     */
    async deleteShipmentDraftRaw(requestParameters: DeleteShipmentDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['shipmentDraftId'] == null) {
            throw new runtime.RequiredError(
                'shipmentDraftId',
                'Required parameter "shipmentDraftId" was null or undefined when calling deleteShipmentDraft().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentDraftId'] != null) {
            queryParameters['shipmentDraftId'] = requestParameters['shipmentDraftId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipment-drafts/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes shipment draft
     * Your GET endpoint
     */
    async deleteShipmentDraft(requestParameters: DeleteShipmentDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteShipmentDraftRaw(requestParameters, initOverrides);
    }

    /**
     * Returns a shipment draft by id
     * Your GET endpoint
     */
    async getShipmentDraftByIdRaw(requestParameters: GetShipmentDraftByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipmentDraft>> {
        if (requestParameters['shipmentDraftId'] == null) {
            throw new runtime.RequiredError(
                'shipmentDraftId',
                'Required parameter "shipmentDraftId" was null or undefined when calling getShipmentDraftById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentDraftId'] != null) {
            queryParameters['shipmentDraftId'] = requestParameters['shipmentDraftId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipment-drafts/get-by-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipmentDraftFromJSON(jsonValue));
    }

    /**
     * Returns a shipment draft by id
     * Your GET endpoint
     */
    async getShipmentDraftById(requestParameters: GetShipmentDraftByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipmentDraft> {
        const response = await this.getShipmentDraftByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of shipment drafts
     * Your GET endpoint
     */
    async getShipmentDraftsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShipmentDraft>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipment-drafts/get-all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShipmentDraftFromJSON));
    }

    /**
     * Returns a list of shipment drafts
     * Your GET endpoint
     */
    async getShipmentDrafts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShipmentDraft>> {
        const response = await this.getShipmentDraftsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns a shipment drafts summary
     * Your GET endpoint
     */
    async getShipmentDraftsSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipmentDraftsSummary>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipment-drafts/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipmentDraftsSummaryFromJSON(jsonValue));
    }

    /**
     * Returns a shipment drafts summary
     * Your GET endpoint
     */
    async getShipmentDraftsSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipmentDraftsSummary> {
        const response = await this.getShipmentDraftsSummaryRaw(initOverrides);
        return await response.value();
    }

}
